import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "header1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "cnt1 clearfix" }, null, -1)
const _hoisted_3 = { class: "cnt2 clearfix" }
const _hoisted_4 = {
  key: 0,
  id: "com_form_contet_admin"
}
const _hoisted_5 = { class: "errorform" }
const _hoisted_6 = {
  key: 0,
  class: "error-message"
}
const _hoisted_7 = {
  class: "form-group",
  style: {"text-align":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GlobalNavikanriComponent = _resolveComponent("GlobalNavikanriComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_GlobalNavikanriComponent, { previewData: _ctx.gloNaviPreviewDataList }, null, 8, ["previewData"])
      ])
    ]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        type: "button",
        name: "btnBack",
        class: "btn btn-back btn-primary",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goback && _ctx.goback(...args)))
      }, " 戻る ")
    ])
  ], 64))
}